import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import * as Services from '../../../sdk/services';
import {
  USUARIOS_BUSCAR_PENDENTE_APROVACAO_BEGIN, USUARIOS_BUSCAR_PENDENTE_APROVACAO_DISMISS_ERROR, USUARIOS_BUSCAR_PENDENTE_APROVACAO_FAILURE, USUARIOS_BUSCAR_PENDENTE_APROVACAO_SUCCESS
} from './constants';

export function buscarPendenteAprovacao(callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIOS_BUSCAR_PENDENTE_APROVACAO_BEGIN,
    callback,
  };
}

export function dismissBuscarPendenteAprovacaoError() {
  return {
    type: USUARIOS_BUSCAR_PENDENTE_APROVACAO_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIOS_BUSCAR_PENDENTE_APROVACAO_BEGIN actions
export function* doBuscarPendenteAprovacao(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioApi = new Services['UsuarioApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioApi.find({
      where: { emailVerified: true, or: [{ username: null }, { username: '' }] },
    });
  } catch (err) {
    yield put({
      type: USUARIOS_BUSCAR_PENDENTE_APROVACAO_FAILURE,
      data: { error: err },
    });
    if (action.callback) {
      action.callback(USUARIOS_BUSCAR_PENDENTE_APROVACAO_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIOS_BUSCAR_PENDENTE_APROVACAO_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIOS_BUSCAR_PENDENTE_APROVACAO_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchBuscarPendenteAprovacao() {
  yield takeLatest(USUARIOS_BUSCAR_PENDENTE_APROVACAO_BEGIN, doBuscarPendenteAprovacao);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_BUSCAR_PENDENTE_APROVACAO_BEGIN:
      return {
        ...state,
        registros: [],
        buscarPendenteAprovacaoPending: true,
        buscarPendenteAprovacaoError: null,
      };

    case USUARIOS_BUSCAR_PENDENTE_APROVACAO_SUCCESS:
      return {
        ...state,
        registros: action.data,
        buscarPendenteAprovacaoPending: false,
        buscarPendenteAprovacaoError: null,
      };

    case USUARIOS_BUSCAR_PENDENTE_APROVACAO_FAILURE:
      return {
        ...state,
        buscarPendenteAprovacaoPending: false,
        buscarPendenteAprovacaoError: action.data.error,
      };

    case USUARIOS_BUSCAR_PENDENTE_APROVACAO_DISMISS_ERROR:
      return {
        ...state,
        buscarPendenteAprovacaoError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuarios/redux/buscarPendenteAprovacao.js